import AmplitudeClient from "amplitude-js/src/amplitude-client";
import AppConfig from "@/constants/AppConfig";

const IS_DEV_ENV = process.env.NODE_ENV === "development";

const amplitude = new AmplitudeClient();
amplitude.init( AppConfig.AmplitudeToken, null, {
	includeReferrer: true,
	includeUtm: true,
	includeGclid: true,
} );

const NO_REQUEST_SENT_CODE = 0;
let userProperties = {};
let userId = null;

export async function event( name, eventProperties = {}, eventClassName = "" ) {
	if ( IS_DEV_ENV ) {
		console.group( `TELEMETRY EVENT ${eventClassName}` );
		console.info( `AMPLITUDE (${userId}):`, name, eventProperties );
		console.groupEnd();
		return;
	}
	amplitude.logEvent( name, eventProperties, ( code, message, details ) => {
		// NOTE: unanticipated exceptions are handled by amplitude's internal logging
		if ( code === NO_REQUEST_SENT_CODE ) {
			console.warn( message, details );
		}
	} );
}

export function setAmplitudeUser( user ) {
	userProperties = {};
	userId = null;
	if ( user ) {
		userProperties = {
			email_address: user.email,
			domain: user.email.replace( /.*@/, "" ),
			...user.props,
		};
		userId = user.email;
	}
	if ( IS_DEV_ENV ) {
		return console.info( "AMPLITUDE: Updated User Props", { userId, userProperties, } );
	}
	// NOTE: these calls will POST to the amplitude API
	amplitude.setUserId( userId );
	amplitude.setUserProperties( userProperties );
}

export function setUserId( email = null ) {
	userId = email;
	if ( IS_DEV_ENV ) {
		return console.info( "AMPLITUDE: Updated User ID", { userId, } );
	}
	// NOTE: this call will POST to the amplitude API
	amplitude.setUserId( userId );
}

const locations = {
	GOALS: "Goals Screen",
	TEAM_MEETING: "In-Meeting",
	PROFILE: "Profile Page",
	TEAMS: "Teams List",
	TEAM_SPACE: "Team Spaces",
	SCHEDULE: "Schedule",
};

export const getLocation = () => {
	const path = window.location.pathname || "";
	if ( path.startsWith( "/schedule" ) ) {
		if ( /\/schedule\/[a-z0-9-]+/.test( path ) ) {
			return locations.TEAM_MEETING;
		}
		return locations.SCHEDULE;
	}
	if ( path.startsWith( "/goals" ) ) {
		return locations.GOALS;
	}
	if ( path.startsWith( "/teams" ) ) {
		if ( /\/teams\/[a-z0-9-]+/.test( path ) ) {
			return locations.TEAM_SPACE;
		}
		return locations.TEAMS;
	}
	if ( path.startsWith( "/me" ) ) {
		return locations.PROFILE;
	}
	return "";
};

export class AmplitudeEvent {
	name = "";
	eventProperties = {};

	async submit() {
		const eventProperties = {
			...{ location: getLocation(), },
			// location may be manually overridden by event properties
			...this.eventProperties,
		};
		return event( this.name, eventProperties, this.constructor.name );
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/AmplitudeEvent.js